import React from "react";
import classes from "./styles.module.scss";
import Link from "next/link";
import Title from "@/ui/Title";
import useBlogs from "@/hooks/useBlogs";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(`${dateString}T00:00:00`);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

export const BlogSection = ({ subtitle = "", title = "" }) => {
  const blogs = useBlogs({ limit: 4 }) ?? [];

  return (
    <div id="blogs" className={classes.section}>
      {subtitle && <Title className={`h5 ${classes.subtitle}`} title={subtitle} tag="div" />}
      {title && <Title className={classes.title} title={title} tag="h4" />}

      <div className={classes.grid}>
        {blogs.map((item, index) => {
          const imageUrl = item.image;
          const blogTitle = item.title;
          const blogDate = item.publish_date;
          const blogSlug = item.url_slug;
          const blogTags = item.blog_type || [];

          return (
            <div key={index} className={classes.blog}>
              {imageUrl && <img className={classes.image} src={imageUrl} alt={blogTitle || "Blog image"} />}
              <div className={classes.content}>
                <div className={classes.metaRow}>
                  <div className={classes.tagContainer}>
                    {blogTags.map((tag, tagIndex) => (
                      <span key={tagIndex} className={classes.tag}>
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className={classes.date}>{formatDate(blogDate)}</span>
                </div>
                <div className={classes.title_card}>{blogTitle}</div>
              </div>
              <div className={classes.cardFooter}>
                <a href={`/blogs/${blogSlug}/`} className={classes.readMore}>
                  Read More
                </a>
                <svg
                  className={classes.plusIcon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M10 0C9.40292 0 8.91892 0.484027 8.91892 1.08108V8.91895H1.08108C0.484027 8.91895 0 9.40295 0 10C0 10.5971 0.484027 11.0811 1.08108 11.0811H8.91892V18.9189C8.91892 19.516 9.40292 20 10 20C10.5971 20 11.0811 19.516 11.0811 18.9189V11.0811H18.9189C19.516 11.0811 20 10.5971 20 10C20 9.40295 19.516 8.91895 18.9189 8.91895H11.0811V1.08108C11.0811 0.484027 10.5971 0 10 0Z" />
                </svg>
              </div>
            </div>
          );
        })}
      </div>

      <div className={classes.cta_section}>
        <div className={classes.pagination}>
          <button className={classes.arrow}>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.0882 19.7841C13.2862 19.5381 13.2442 19.1803 12.9935 18.9855L11.2228 17.6086L8.8967 15.5665L23.4223 15.5665C23.7416 15.5665 24 15.3119 24 14.998C24 14.6842 23.7416 14.4295 23.4223 14.4295L9.04188 14.4295L13.0775 10.9984C13.3185 10.7938 13.3459 10.4345 13.1372 10.1968C12.9284 9.9592 12.5637 9.93305 12.3223 10.1385L7.0574 14.6149C6.93147 14.7217 6.85868 14.8768 6.85714 15.0405C6.85714 15.042 6.85714 15.0435 6.85714 15.045C6.85714 15.2073 6.92724 15.3615 7.05009 15.4691L10.4799 18.4788L12.2768 19.8773C12.5271 20.0721 12.8903 20.0304 13.0882 19.7841Z"
                fill="white"
              />
            </svg>
          </button>

          <button className={classes.arrow}>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.9117 10.2159C16.7138 10.4619 16.7558 10.8197 17.0065 11.0145L18.7772 12.3914L21.1033 14.4335L6.57767 14.4335C6.25841 14.4335 6 14.6881 6 15.002C6 15.3158 6.25841 15.5705 6.57767 15.5705L20.9581 15.5705L16.9225 19.0016C16.6815 19.2062 16.6541 19.5655 16.8628 19.8032C17.0716 20.0408 17.4363 20.0669 17.6777 19.8615L22.9426 15.3851C23.0685 15.2782 23.1413 15.1232 23.1429 14.9595C23.1429 14.958 23.1429 14.9565 23.1429 14.955C23.1429 14.7927 23.0728 14.6385 22.9499 14.5309L19.5201 11.5212L17.7232 10.1227C17.4729 9.92786 17.1097 9.96956 16.9117 10.2159Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
